import React from "react";
import { View, Text } from "react-native";
import { DatePickerInput } from 'react-native-paper-dates';
import DatePicker from 'react-date-picker';
import FormFieldTitle from "./FormFieldTitle";
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
 import './datePicker_web.css';

interface PaperDatesProps {
  field: any;
  control: any;
  editable: boolean;
  styles: any;
  Ctrl: any;
  errors:any;
}

const DatePickerHookControl: React.FC<PaperDatesProps> = ({ field, control, editable, styles, Ctrl, errors, }) => {
  const rule = field.required ? 
                { required: field.label + ' is required', 
                  //validate: (val:any) => proceedToCreate(val, packageStatusItems) || "Adding / Editing for this period is locked. Choose a month with Open / Re-Open status.",
                } 
                :
                { required: false, 
                  //validate: (val:any) => proceedToCreate(val, packageStatusItems) || "Adding / Editing for this period is locked. Choose a month with Open / Re-Open status."
                };
  const [inputDate, setInputDate] = React.useState(undefined);

let date = null;
if (field.defaultValue && field.defaultValue !== null)
{
  const dateString = field.defaultValue;
  const parts = dateString.split('/');
  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1; // Month is zero-based
  const year = parseInt(parts[2], 10);
  date = new Date(year, month, day);
  console.log("Inside control: " + field.defaultValue + " = " +  date)
}

  return (
    <View style={{ flexDirection: 'column', paddingTop: 6, overflow: 'visible', position: 'relative', zIndex: 1000 }}>
      <View style={{width:'100%'}}>{ <FormFieldTitle field={field}/> }</View>
      
      {editable === false ? <View><Text style={{fontWeight:'normal', fontSize:12}}>{field.defaultValue ?? null}</Text></View> :
      <Ctrl
        key={field.key}
        control={control}
        name={field.key}
        rules={rule}
        
        //defaultValue={field.defaultValue && date && date !== null ? date : null}
        render={({ field: { onChange, onBlur, value } }: { field: { onChange: any, onBlur: any, value: any } }) => (
          // <DatePickerInput
          //   locale="en-gb"
          //   label={null}
          //   value={value}
          //   onChange={(date) => onChange(date)}
          //   inputMode="start"
          //   style={styles}
          //   editable={editable}
          //   disabled={!editable}
          //   //date={field.defaultValue && field.defaultValue}
          //   onBlur={onBlur}
          //   //ref={ref}
          // />
          <div style={{ position: 'relative', zIndex: 9999 }}>
                        <DatePicker
                          className="custom-date-picker"
                          onChange={(date) => onChange(date)}
                          value={value}
                          onBlur={onBlur}
                          locale="en-US"
                        />
                      </div>
        )}
      />
        }
        {errors[field.key]?.message && <Text style={{ color: 'red' }}>{errors[field.key]?.message}</Text>}
    </View>
  );
};

export default DatePickerHookControl;
